"use strict";

const MuniCulvertPopup = function () {
  let popups = {};

  var getPopupHtml = function (properties) {
    properties.permissions = UserPermissions.getAllPermissions();
    properties.canEditInventory = HardAssetInventoryModalController.canEditInventory("culvert");
    properties.canCreateRoutineInspection =
      properties.canCreateRoutineInspection &&
      HardAssetInspectionGate.isEnabledForAssetType("culvert");
    return PopupContent.getLayerPopup(properties, "muniCulvert");
  };

  var onPopupOpen = async function (properties) {
    const data = await getPopupData(properties.id);
    const html = getPopupHtml(data);
    $(".leaflet-popup-content").html(html);

    const layerName = "muniCulvert";
    const layerModule = LayerFunctions.getLayerModule(layerName);

    const $popup = $(".leaflet-popup-content");
    $popup.html(html);
    onPopupOpenWithData(data, $popup, layerModule.invalidateLayerData);
  };

  var onPopupOpenWithData = function (data, $element, invalidateLayerDataFunction) {
    var onPopupDelete = function () {
      deleteOpenChannel(data.id, data.name, invalidateLayerDataFunction);
    };

    $element.off("click", ".popup-delete-button", onPopupDelete);
    $element.on("click", ".popup-delete-button", onPopupDelete);

    MuniPopup.bindListeners($element, invalidateLayerDataFunction);
    MuniPopup.renderInspectionHistory(
      data.history,
      "culvert",
      data.id,
      data.canCreateRoutineInspection,
    );
  };

  var deleteOpenChannel = function (id, name, invalidateLayerDataFunction) {
    const popupCloseButn = $(".leaflet-popup-close-button");
    MessageModal.showConfirmWarningModal(
      `Delete Culvert ${name}? Click "Delete" to permanently delete the Culvert. Click "Cancel" to return.`,
      async function () {
        await ApiCalls.deleteCulvert(id);
        invalidateLayerDataFunction();
        _closePopup(popupCloseButn);
      },
      "Cancel",
      "Delete",
    );
    Analytics.sendPopupEvent("delete_asset", "culverts");
  };

  var _closePopup = function (popupCloseButn) {
    if (popupCloseButn.length) {
      popupCloseButn[0].click();
    }
  };

  var getPopupData = async function (id) {
    if (popups[id]) {
      return popups[id];
    }
    const popupData = await ApiCalls.getMuniCulvertPopup(id);
    const condition = popupData.lastMaintenanceInspection?.condition ?? null;
    popupData.icon = {
      class: RoutineMaintenanceIcon.getConditionClass("muni-culvert", condition),
      color: RoutineMaintenanceIcon.getConditionColor(condition),
    };
    popupData.displayDiameterUnits = UnitConversion.getUnitAbbreviation(popupData.diameterUnits);
    popupData.displayLengthUnits = UnitConversion.getUnitAbbreviation(popupData.lengthUnits);
    popupData.displayWidthUnits = UnitConversion.getUnitAbbreviation(popupData.widthUnits);
    // eslint-disable-next-line require-atomic-updates
    popups[id] = popupData;
    return popupData;
  };

  var getPopupLatLng = async function (id) {
    const data = await getPopupData(id);
    return data?.midpointLatLng;
  };

  var invalidatePopupCache = function () {
    popups = {};
  };

  return {
    getPopupHtml,
    onPopupOpen,
    getPopupLatLng,
    invalidatePopupCache,
  };
};

module.exports = MuniCulvertPopup();

const ApiCalls = require("../../apiCalls");
const PopupContent = require("../../mapFunctions/popupContent");
const MessageModal = require("../../modals/messageModal");
const LayerFunctions = require("../../layerFunctions");
const UserPermissions = require("../../login/userPermissions");
const HardAssetInspectionGate = require("../hardAssetInspectionGate");
const HardAssetInventoryModalController = require("../hardAssetInventoryModalController");
const Analytics = require("../../general/analytics");
const MuniPopup = require("../muniPopup");
const RoutineMaintenanceIcon = require("../../general/routineMaintenanceIcon");
const UnitConversion = require("../../unitConversion");
